import React from "react";
import "./Csoon.scss";
import Comingsoon from "../../Media/Florence_Desktop.webp";
import Soon from "../../Media/Florence_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=628111607096&text=Halo%20Andrian,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20jakarta%20Garden%20City%20(Florence)%20https://marketing-jakartagardencity.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Florence" className="container-soon">
      <div className="louise">
        <h1>New Launching Jakarta Garden City</h1>
        <h2>Florence</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-Desktop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
